import axios from 'axios';
import miscFunctions from '../helpers/misc-functions';
import apiRecordLayoutFunctions, { location_collection_complete } from '../helpers/apiRecordLayoutFunctions.js';
import Metadata from '../helpers/metadata/Metadata';
import DataModel from '../models/DataModel.js';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';

let helpers = {
  getLocations(searchString = '', marketId, page, perPage, company, options){
    let request = null;
    if (page && perPage) {
      request = process.env.REACT_APP_API + '/locations?current_company=' + (company ? company.id : localStorage.current_company_id)  + '&keywords=' + (searchString ? searchString : '') +
        '&page=' + page + '&per=' + Math.floor(perPage);
    } else {
      request = process.env.REACT_APP_API + '/locations?current_company=' + (company ? company.id : localStorage.current_company_id)  + '&keywords=' + (searchString ? searchString : '');
    }
    if (marketId) {
      request += '&market_id=' + marketId;
    }
    if (options && options.recordDescriptor) {
      request +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: request,
      timeout: 120000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else if (response.data.data) {
          if (response.data.meta) {
            let record = miscFunctions.mapApiJson(response.data);
            record = location_collection_complete.postProcess(record);
            return {
              locations: record,
              lastLocationsPage: parseInt(response.data.meta.last_page, 10),
              totalLocations: parseInt(response.data.meta.total_records, 10),
            };
          }
          else {
            let record = miscFunctions.mapApiJson(response.data);
            record = location_collection_complete.postProcess(record);
            return record;
          }
        }
        else {
          if (response.data.meta) {
            return {
              locations: response.data.locations,
              lastLocationsPage: parseInt(response.data.meta.last_page, 10),
              totalLocations: parseInt(response.data.meta.total_records, 10),
            };
          } else {
            return response.data.locations;
          }
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getProjectLocations(project_id, company, options){
    let request = process.env.REACT_APP_API + '/locations/project_locations?current_company=' +
      (company ? company.id : localStorage.current_company_id) + '&project_id=' + project_id;
    if (options && options.recordDescriptor) {
      request +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    else {
      request += '&filtering=' + apiRecordLayoutFunctions.getEncodedRecordLayout(location_collection_complete);
    }
    return axios({
      method: 'get',
      url: request,
      timeout: 120000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getLocationsWithProjects(searchString = '', filter, options){
    let request = null;
    request = process.env.REACT_APP_API + '/locations/with_projects?current_company=' + localStorage.current_company_id  + '&keywords=' + (searchString ? searchString : '');
    if (options && options.recordDescriptor) {
      request +=  '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    if (!miscFunctions.isEmpty(filter)) {
      if (filter.project_managers) {
        // NOTE: axios does not seem to escape % characters (or rails
        // doesn't handle % by itself correctly) hence the replace
        let projectManagers = '&project_manager=' + filter.project_managers.map(pm => { return pm.id; }).join(',');
        request += projectManagers;
      }
      if (filter.project_types) {
        let projectTypes = '&project_type=' + filter.project_types.map(pt => { return pt.id; }).join(',');
        request += projectTypes;
      }
      if (filter.statuses) {
        request += '&project_status=' + filter.statuses.join(',');
      }
    }
    if (options.allProjects) {
      request += '&all_projects=true';
    }
    if (options.marketIds) {
      request += '&markets=' + options.marketIds.join(',');
    }
    return axios({
      method: 'get',
      url: request,
      timeout: 120000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getAllLocations() {
    let request =
      process.env.REACT_APP_API +
      '/locations/all_locations?current_company=' +
      localStorage.current_company_id;

    request += '&filtering=' + apiRecordLayoutFunctions.getEncodedRecordLayout(location_collection_complete);
    return axios({
      method: 'get',
      url: request,
      timeout: 120000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        if (response.data.data) {
          let record = miscFunctions.mapApiJson(response.data, apiRecordLayoutFunctions.getRecordLayout(location_collection_complete));
          record = location_collection_complete.postProcess(record);
          return record;
        }
        else {
          return response.data.locations;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getMyLocations(searchString = '', page, perPage, company) {
    let request = null;
    if (page) {
      request = process.env.REACT_APP_API + '/locations/my_locations?current_company=' + (company ? company.id : localStorage.current_company_id) + '&keywords=' + (searchString ? searchString : '') +
        '&page=' +
        page +
        '&per=' +
        (perPage ? perPage : 7);
    } else {
      request = process.env.REACT_APP_API + '/locations/my_locations?current_company=' + (company ? company.id : localStorage.current_company_id) + '&keywords=' + (searchString ? searchString : '');
    }
    return axios({
      method: 'get',
      url: request,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        if (response.data.meta) {
          return {
            locations: response.data.locations,
            lastLocationsPage: parseInt(response.data.meta.last_page, 10),
            totalLocations: parseInt(response.data.meta.total_records, 10),
          };
        } else {
          return response.data.locations;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getMyLocationsCount(user) {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/locations/count_my_locations?current_company=' +
        localStorage.current_company_id +
        '&user_id=' +
        user.id,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  search(searchString, guid, company){
    let request = null;
    request = process.env.REACT_APP_API + '/locations/search?current_company=' + (company ? company.id : localStorage.current_company_id) 
              + (searchString ? '&keywords=' + searchString : '') + (guid ? '&guid=' + guid : '');
    return axios({
      method: 'get',
      url: request,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
        Company: localStorage.current_company_id,
      },
    })
    .then(response => {
      if (response.data.meta) {
        return {
          locations: response.data.locations,
          lastLocationsPage: parseInt(response.data.meta.last_page, 10),
          totalLocations: parseInt(response.data.meta.total_records, 10),
        };
      } else {
        return response.data.locations;
      }
    })
    .catch(error => {
      return serviceUtil.resultForError(error);
    });
  },
  getLocation(id, options) {
    let url = process.env.REACT_APP_API + '/locations/' + id + '?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor){
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    else{
      url += '&filtering=' + apiRecordLayoutFunctions.getEncodedRecordLayout(location_collection_complete);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (response.data.data) {
          if (options) {
            return response.data;
          }
          else {
            let record = miscFunctions.mapApiJson(response.data);
            record = location_collection_complete.postProcess(record);
            return record;
          }
        }
        else {
          return response.data.location;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  getLocationCategories() {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/location-categories/?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        Pragma: 'no-cache',
        Expires: '0',
        'Content-Type': 'application/json',
        Accept: '*/*',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        let locationCategories = {};
        for (var i = 0; i < response.data.location_categories.length; i++) {
          locationCategories[response.data[i].name] = response.data[i];
        }
        return locationCategories;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  createLocation(location, eventMetadatum, options) {
    location.company_id = location.company
      ? location.company.id
      : location.company_id;
    location.user_id = location.user ? location.user.id : location.user_id;
    delete location.company;
    delete location.user;
    delete location.parent;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/locations?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        location: location,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          return response.data.location;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateLocation(location, eventMetadatum, options) {
    location.user_id = location.user ? location.user.id : location.user_id;
    delete location.user;
    location.company_id = location.company
      ? location.company.id
      : location.company_id;
    delete location.company;
    delete location.locations;
    delete location.parent;
    delete location.market;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/locations/' +
        location.id +
        '?current_company=' +
        localStorage.current_company_id,
      data: {
        eventMetadatum: eventMetadatum,
        location: location,
      },
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options) {
          return response.data;
        }
        else {
          let record = miscFunctions.mapApiJson(response.data);
          record = location_collection_complete.postProcess(record);
          return record;
        }
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteLocation(location_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/locations/' +
        location_id +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      data: {
        eventMetadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        DataModel.displayInfoErrorMessage('Location succesfully deleted', 4000, 1);
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  checkLocationGUID(guid) {
    return axios({
      method: 'get',
      url:
        process.env.REACT_APP_API +
        '/location/check_guid?guid=' +
        guid +
        '&current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },

  /** LOCATION-USER OPERATIONS */
  createLocationUser(locationUser, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url:
        process.env.REACT_APP_API +
        '/locations/' +
        locationUser.locationId +
        '/users' +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        location_user: {  
          title: locationUser.title,
          user_id: locationUser.user.id,
        },
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  updateLocationUser(locationUser, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'patch',
      url:
        process.env.REACT_APP_API +
        '/locations/' +
        locationUser.location_id +
        '/users/' + 
        locationUser.id +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
      data: {
        event_metadatum: eventMetadatum,
        location_user: {  
          title: locationUser.title,
          user_id: locationUser.user.id,
        },
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteLocationUser(locationId, locationUserId, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url:
        process.env.REACT_APP_API +
        '/locations/' +
        locationId +
        '/users/' + 
        locationUserId +
        '?current_company=' +
        localStorage.current_company_id,
      timeout: 20000,
      data: {
        event_metadatum: eventMetadatum,
      },
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/locationsService.js